export class UpdateChargeAccountEntity {
    user;
    chargeAccountData;

    constructor(user, chargeAccountData) {
        this.user = user;
        this.chargeAccountData = chargeAccountData;
    }
}